import _extends from "@babel/runtime/helpers/esm/extends";
import { getType } from 'typesafe-actions';
import { appConfigActions } from './actions';
export var initialState = {
  appName: 'SRIN Web UI',
  companyName: 'SRIN',
  appLogo: null,
  pageTitle: ''
};
export var reducer = function reducer(state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case getType(appConfigActions.setAppName):
      return _extends({}, state, {
        appName: action.payload
      });

    case getType(appConfigActions.setCompanyName):
      return _extends({}, state, {
        companyName: action.payload
      });

    case getType(appConfigActions.setAppLogo):
      return _extends({}, state, {
        appLogo: action.payload
      });

    case getType(appConfigActions.setHeaderLogo):
      return _extends({}, state, {
        headerLogo: action.payload
      });

    case getType(appConfigActions.setPageTitle):
      return _extends({}, state, {
        pageTitle: action.payload
      });

    default:
      return state;
  }
};